import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Row,
  Col,
  Select,
  Upload,
  message,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { getBase64, beforeUpload } from "../../../utils/handlePhoto";
import API from "../../../services/api-request";

const AddUsers = (props) => {
  const [addForm] = Form.useForm();
  const [privilegeOptions, setPrivilegeOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);

  const getPrivilegeOptions = async (general_role) => {
    await API.Get(`privilege?generale_role=${general_role}`)
      .then((result) => {
        setPrivilegeOptions(
          result.data.map((e) => {
            return { value: e.id, label: e.name };
          })
        );
      })
      .catch((err) => {
        message.info("Failed Fetch Data Privilege!");
        console.error(err);
      });
  };

  const getClientOptions = async () => {
    await API.Get("client")
      .then((result) => {
        setClientOptions(
          result.data.map((e) => {
            return { value: e.id, label: e.name };
          })
        );
      })
      .catch((err) => {
        message.info("Failed Fetch Data Client!");
        console.error(err);
      });
  };

  const onValuesChange = (changedValues, allValues) => {
    getPrivilegeOptions(allValues.general_role);
    if (
      changedValues.general_role === "admin" ||
      changedValues.general_role === "client"
    )
      addForm.setFieldValue("privilege_id", null);
  };

  const onFinish = async (values) => {
    const {
      name,
      email,
      username,
      password,
      privilege_id,
      general_role,
      client_id,
      image,
    } = values;

    const dataForm = {
      name,
      email,
      username,
      password,
      privilege_id,
      general_role,
      client_id: client_id ?? "",
      image,
    };

    const formData = new FormData();

    for (const property in dataForm) {
      formData.append(`${property}`, dataForm[property]);
    }
    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ", " + pair[1]);
    // }

    await API.Post("user/create", formData)
      .then(() => {
        message.success("User has been added");
        props.onGetUsers();
        addForm.resetFields();
        setFileList([]);
        props.onShowAdd(false);
      })
      .catch((err) => {
        console.error(err);
        if (!err.response.data) {
          message.info("Failed add user");
        }

        message.info(
          `${err.response.data.errors[0].path} ${err.response.data.errors[0].msg}`
        );
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowAdd(false);
    addForm.resetFields();
    setFileList([]);
  };

  // File Upload Variable & Function
  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const getFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.file.originFileObj;
  };

  useEffect(() => {
    getPrivilegeOptions("client");
    getClientOptions();
  }, [props.showAdd]);
  return (
    <>
      <Modal
        title="Add Users"
        open={props.showAdd}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => addForm.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={addForm}
          name="Add Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onValuesChange={onValuesChange}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please input your name!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please input your email!" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Confirm Password"
                name="password2"
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: "Please input your confirm password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "The new password that you entered do not match!"
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  { required: true, message: "Please input your username!" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Client" name="client_id">
                <Select options={clientOptions} allowClear />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                initialValue="client"
                label="General Role"
                name="general_role"
                rules={[
                  {
                    required: true,
                    message: "Please input your general role!",
                  },
                ]}
              >
                <Select
                  options={[
                    { value: "admin", label: "Admin" },
                    { value: "client", label: "Client" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Privilege"
                name="privilege_id"
                rules={[
                  { required: true, message: "Please input your privilege!" },
                ]}
              >
                <Select options={privilegeOptions} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Row>
                <Col span={11}>
                  <Form.Item
                    label="Upload Photo"
                    name="image"
                    getValueFromEvent={getFile}
                  >
                    <Upload
                      maxCount={1}
                      customRequest={dummyRequest}
                      listType="picture-card"
                      fileList={fileList}
                      beforeUpload={beforeUpload}
                      onPreview={handlePreview}
                      onChange={handleChange}
                    >
                      {fileList.length >= 1 ? null : (
                        <button
                          style={{ border: 0, background: "none" }}
                          type="button"
                        >
                          <PlusOutlined />
                          <div style={{ marginTop: 8 }}>Upload</div>
                        </button>
                      )}
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <ul style={{ fontSize: "10px" }}>
                    <li>Must be {"<"} 2MB!</li>
                    <li>Must be JPEG/PNG</li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        open={previewOpen}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    </>
  );
};
export default AddUsers;
